import FinancePassword from './FinancePassword';

export default FinancePassword;
